import type { CostExplorerDisplayUnit } from '@repo/cost-explorer-ui';

const threshold = 0.01;

export const formatNumber = (value: number, fractionDigits = 2) => {
  if (fractionDigits && threshold > value && value > 0) {
    return `<${threshold}`;
  }

  return value.toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

const compactFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});

export const formatCompactNumber = (value: number) =>
  compactFormatter.format(value);

const withCurrencyPrefix = (
  formatted: string,
  costUnit: CostExplorerDisplayUnit
) => {
  const currencyPrefix =
    costUnit === 'USD' ? '$' : costUnit === 'CAD' ? 'CA$' : undefined;
  if (!currencyPrefix) {
    return formatted;
  }
  return formatted.startsWith('<')
    ? `<${currencyPrefix}${formatted.slice(1)}`
    : `${currencyPrefix}${formatted}`;
};

export const formatAmount = (
  value: number,
  costUnit: CostExplorerDisplayUnit,
  fractionDigits = 2
) => withCurrencyPrefix(formatNumber(value, fractionDigits), costUnit);

export const formatCompactAmount = (
  value: number,
  costUnit: CostExplorerDisplayUnit
) => withCurrencyPrefix(formatCompactNumber(value), costUnit);
